<template>
  <div class="operation_box">
    <div class="operation_item">
      <el-dropdown v-if="canViewDetails"
                   split-button type="primary"
                   @click="showUserDetails"
                   @command="(command) => command()"
      >
        <i class="fa fa-user"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="showUserDetails" v-if="canViewDetails">
            <i class="fa fa-user"></i>
            {{ $t("management.team.table.operation.showUserDetails")}}
          </el-dropdown-item>
          <el-dropdown-item :command="showPermissions" v-if="canViewPermissions">
            <i class="fa fa-low-vision"></i>
            {{ $t("management.team.table.operation.showPermissions")}}
          </el-dropdown-item>
          <el-dropdown-item :command="handOver" v-if="isHandOverAllowed">
            <i class="fa fa-handshake"></i>
            {{ $t("management.team.table.operation.handOver")}}
          </el-dropdown-item>
          <el-dropdown-item :command="sendActivationMail" v-if="requiresMailVerification">
            <i class="fa fa-paper-plane"></i>
            {{ $t("management.team.table.operation.sendActivationMail")}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

export default {
  props: {
    params: Object
  },
  computed: {
    user() {
      return this.params.data;
    },
    requiresMailVerification() {
      return this.user.userStatus === enumDef.userStatus.New;
    },
    isHandOverAllowed() {
      return this.user.userStatus === enumDef.userStatus.Active
          && this.user.userLevel === enumDef.userLevel.ManagerUser
          && this.currentUser.level === enumDef.userLevel.RootUser;
    },
    canViewDetails() {
      return this.currentUser.userId === this.user.id
          || this.currentUser.level < this.user.userLevel;
    },
    canViewPermissions() {
      return this.currentUser.userId === this.user.id
          || this.currentUser.level < this.user.userLevel;
    }
  },
  methods: {
    showUserDetails() {
      this.params.showUserDetails(this.params.data);
    },
    sendActivationMail() {
      this.params.sendActivationMail(this.params.data);
    },
    showPermissions() {
      this.params.showPermissions(this.params.data);
    },
    handOver() {
      this.params.handOver(this.params.data);
    }
  }
};
</script>